import breedingManagementService from "@/app/services/main/breeding-management/breeding-management-service.js";
import DatePicker from "vue2-datepicker"

import { STATUS_CODES } from "@/app/constants/status-constants"

// Mixins
import { tableMixins } from "@/app/mixins/utils/table-mixins"
import { dateMixins } from "@/app/mixins/utils/date-mixins"
import { toastMessageMixins } from "@/app/mixins/utils/toast-message-mixins"


const ModalAddEditLitterNotes = () =>
    import(
        /* webpackPrefetch: true, webpackChunkName: "modal-add-edit-litter-notes" */ "@/app/views/main-view/breeding-management/puppy-management/modals/modal-add-edit-litter-notes/modal-add-edit-litter-notes.vue"
    );
export default {
    name: 'LitterNoteComponent',
    components: { DatePicker, ModalAddEditLitterNotes },
    directive: {},
    filters: {},
    mixins: [tableMixins, dateMixins, toastMessageMixins],
    props: {},
    data() {
        return {
            isAPILoading: false,
            // table
            theads: [
                { name: null, searchLabel: null, sortLabel: null, isDesc: false, style: "width: 100px" },
                {
                    name: "Litter Note",
                    searchLabel: "f_notes",
                    sortLabel: "notes",
                    hasSearch: true,
                    isDesc: false,
                    style: "min-width: 200px;"
                },
                {
                    name: "Date",
                    hasSearch: false,
                    hasDateFilter: true,
                    searchLabel: "f_createdDate",
                    sortLabel: "createdDate",
                    isDesc: false,
                    style: "min-width: 170px;",
                    placeholder: 'DD-MMM-YYYY'
                },
                
            ],
            selectedDateFilter: '',
			matingId: null,
            
            noteId: '',
            litterNote: '',

            limit: 10,
			page: 1,
			desc: true,
			totalCount: 0,
        }
    },
    computed: {},
    watch: {
        selectedDateFilter() {
			this.getTableContent(this.page, this.limit, this.sortBy, this.desc, true)
		}
    },
    created() { 
        this.matingId = this.$route.query.matingId;
		this.getTableContent()
    },
    methods: {
        getTableContent(page = this.page, limit = this.limit, sortBy = this.sortBy, desc = this.desc, fromFilter = false) {
			page = fromFilter ? 1 : this.page
			this.getLitterNotes({ page, limit, sortBy, desc })
		},
        async getLitterNotes(queryParams) {
			this.isAPILoading = true

			if (this.columnsFilter) {
				if (this.columnsFilter.f_notes) {
					queryParams["f_notes"] = this.columnsFilter.f_notes
				}
			}

			if (this.selectedDateFilter) {
				queryParams["f_createdDate"] = this.formatDateWithoutConversion(this.selectedDateFilter, "yyyy-MM-dd");
			}

			try {
				const res = await breedingManagementService.getLitterNotes(this.matingId, queryParams);
				if (res.status === STATUS_CODES.SUCCESS) {
					this.tableContent = {
						tableData: res.data.data,
						paginationData: res.data.pagination,
					}

				} else {
					this.showGenericErrorToast();
				}
			} catch (err) {
				this.showGenericErrorToast();
			} finally {
				this.isAPILoading = false;
			}
		},
        showAddEditLitterNoteModal(action, noteData) {
            this.$refs.modalAddEditLitterNotes.show({ action, content: noteData, matingId: this.matingId });
        },
    },
    // third party libraries
}